import * as React from "react";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { SnapshotCollectionsOutcomesRowActions } from "../list/rowActions";

interface Props {
  businessReportOutcome: BusinessReportOutcome;
}

export const SnapshotCollectionsOutcomesSearchRow: React.FC<Props> = ({ businessReportOutcome }) => (
  <tr>
    <td className="py-4 pl-4 pr-3 text-sm sm:pl-6" title={businessReportOutcome.name}>
      <div className="truncate font-medium text-gray-900">{businessReportOutcome.name}</div>
      <div className="mt-2 text-sm text-gray-500">{businessReportOutcome.answer}</div>
      {businessReportOutcome.fs_entry && (
        <div className="mt-2 text-sm text-gray-400">{businessReportOutcome.fs_entry.document_name}</div>
      )}
    </td>

    <td className="whitespace-nowrap pl-3">
      <SnapshotCollectionsOutcomesRowActions businessReportOutcome={businessReportOutcome} />
    </td>
  </tr>
);
